import { WarningTwoIcon } from "@chakra-ui/icons";
import { Button, Container, Heading, Icon, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ActivationFailed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Container maxW="md" textAlign="center">
      <VStack spacing={4} align="center">
        {/* Warning Icon */}
        <Icon as={WarningTwoIcon} color="red.500" boxSize={14} mb={4} />
        <Heading as="h1" size="lg" mb={2}>
          {t("activation.failed.something_went_wrong")}
        </Heading>
        <Text fontSize="lg" mb={2}>
          {t("activation.failed.main_message")}
        </Text>
        <Text fontSize="lg" color="gray.600" mb={4}>
          {t("activation.failed.sub_message")}
        </Text>
        <Button colorScheme="green" size="lg" onClick={handleGoHome}>
          {t("activation.failed.go_home")}
        </Button>
      </VStack>
    </Container>
  );
};

export default ActivationFailed;
